<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">特权角色</div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="paramData">
            <el-form-item label="状态">
               <el-select v-model="queryForm.status" placeholder="请选择状态" @change="bindStausChange">
                  <el-option v-for="(item, index) in statusOptions" :key="index" :label="item" :value="index - 1">
                  </el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button class="margin-left-10" type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="tableData" border>
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" label="角色" prop="name" />
            <el-table-column align="center" label="用户人数" prop="number" />
            <el-table-column align="center" label="发视频动态权限">
               <template scope="{ row }">
                  <div>{{ row.videoEnabled === 0 ? '开启' : '关闭' }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="免除广告权限">
               <template scope="{ row }">
                  <div>{{ row.advertisingEnabled === 0 ? '开启' : '关闭' }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="后台创作权限">
               <template scope="{ row }">
                  <div>{{ row.creationEnabled === 0 ? '开启' : '关闭' }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="核心主题" prop="coreThemeName"></el-table-column>
            <el-table-column align="center" label="欢迎图">
               <template scope="{ row }">
                  <div class="img-wrap"><img :src="row.homePicture" alt="欢迎图" /></div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="续费图">
               <template scope="{ row }">
                  <div class="img-wrap"><img :src="row.renewUrl" alt="续费图" /></div>
               </template>
            </el-table-column>

            <el-table-column align="center" label="标志">
               <template scope="{ row }">
                  <div class="img-wrap"><img :src="row.logo" alt="标志" /></div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="最后操作" width="170px">
               <template scope="{ row }">
                  <div>
                     <div>{{ row.updateUser }}</div>
                     <div>{{ new Date(row.updateTime).format('yyyy-MM-dd hh:mm:ss') }}</div>
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态" prop="status">
               <template scope="{ row }">
                  {{ statusOptions[row.status + 1] }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200px">
               <template scope="{ row }">
                  <el-button type="text" title="编辑" @click="handleEdit(row)">编辑</el-button>
                  <el-button v-if="row.status === 1" type="text" title="开启" @click="handleOpen(row)">开启</el-button>
                  <!-- <el-button v-if="row.status === 0" style="color: red" type="text" title="关闭"
                     @click="handleClose(row)">
                     关闭
                  </el-button> -->
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination layout="total, prev, pager, next, jumper" :total="tableTotal" :page-size="queryForm.pageSize"
            @current-change="handleCurrentChange" :current-page.sync="queryForm.pageNum">
         </el-pagination>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         queryForm: {
            status: -1,
            pageNum: 1,
            pageSize: 10
         },
         statusOptions: ["全部", "开启", "关闭"],
         tableData: [],
         tableTotal: 0
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询特权角色列表
      async queryList() {
         try {
            this.loading = true;
            const result = await this.$http({
               method: "POST",
               url: this.$util.domain + "/adminapi/privilege/v1/list",
               dataType: "json",
               body: JSON.stringify({
                  ...this.queryForm
               })
            });
            if (result.body.data && JSON.stringify(result.body.data) !== "{}") {
               const { totalElements, content } = result.body.data;
               this.tableTotal = totalElements || 0;
               if (content && content.length) {
                  this.tableData = content;
               } else {
                  this.tableData = [];
               }
            } else {
               this.tableData = [];
               this.tableTotal = 0;
               result.body.error === 10000 &&
                  this.$message.error(result.body.message || "请联系技术人员");
            }
         } catch (error) {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error(result.body.message || "请联系技术人员");
         } finally {
            this.loading = false;
         }
      },
      // 更新状态
      async updateStatus(params) {
         try {
            const result = await this.$http({
               url: this.$util.domain + "/adminapi/privilege/v1/openOrClose",
               method: "POST",
               dataType: "json",
               body: JSON.stringify({
                  ...params
               })
            });
            if (result.body.error == 10000) {
               this.$message({
                  type: "success",
                  message: "操作成功!"
               });
               this.queryList();
            } else {
               this.$message({
                  type: "error",
                  message: result.body.message
               });
            }
         } catch (error) {
            this.$message({
               type: "error",
               message: "操作失败"
            });
         }
      },
      // 切换状态
      bindStausChange() {
         this.queryForm.pageNum = 1;
         this.queryForm.pageSize = 10;
         this.queryList();
      },
      // 点击重置
      clickReset() {
         this.paramData = {
            status: -1,
            pageNum: 1,
            pageSize: 10
         };
         this.queryList();
      },
      // 新增
      handleAdd() {
         this.$router.push({
            path: "/yunying/user/privilege/role/detail"
         });
      },
      // 编辑
      handleEdit(row) {
         this.$router.push({
            path: "/yunying/user/privilege/role/detail",
            query: {
               option: encodeURIComponent(
                  JSON.stringify({
                     roleId: row.id
                  })
               )
            }
         });
      },
      // 开启
      handleOpen(row) {
         this.$confirm("确认开启该角色？", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
         }).then(() => {
            this.updateStatus({
               roleId: row.id,
               status: true
            });
         });
      },
      // 关闭
      handleClose(row) {
         this.$confirm("注意！关闭后该角色所有用户将变为普通用户？", "", {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
         }).then(() => {
            this.updateStatus({
               roleId: row.id,
               status: false
            });
         });
      },
      // 切换页数
      handleCurrentChange(val) {
         this.queryForm.pageNum = val;
         this.queryList();
      },
   }
}
</script>

<style scoped>
.img-wrap {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 10px 10px;
}

.img-wrap img {
   width: 100px;
   height: 100px;
   object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// PrivilegeRole.vue?de771588